// Avatar generation utilities — mirrors AvatarComponent Ruby logic

export const AVATAR_COLORS = [
  { bg: 'rgb(201,221,209)', text: 'rgb(53,102,74)' },
  { bg: 'rgb(214,219,233)', text: 'rgb(59,78,122)' },
  { bg: 'rgb(238,214,208)', text: 'rgb(138,63,52)' },
  { bg: 'rgb(217,212,232)', text: 'rgb(79,61,126)' },
  { bg: 'rgb(230,220,200)', text: 'rgb(122,95,42)' },
  { bg: 'rgb(207,225,230)', text: 'rgb(39,87,100)' },
  { bg: 'rgb(224,211,193)', text: 'rgb(109,79,44)' },
  { bg: 'rgb(228,217,192)', text: 'rgb(123,106,63)' },
]

// Mirrors Ruby: @id.delete('-').to_i(16) % COLORS.length
export function avatarColorIndex(uuid) {
  const hex = uuid.replace(/-/g, '')
  let result = 0
  for (const char of hex) {
    result = (result * 16 + parseInt(char, 16)) % AVATAR_COLORS.length
  }
  return result
}

export function avatarInitials(name) {
  return name.split(' ').filter((w) => w.length > 0).slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase()
}

// Colorful avatar for dropdown list items (28×28, AvatarComponent palette)
export function avatarHtml(value, name) {
  const idx = avatarColorIndex(value)
  const color = AVATAR_COLORS[idx]
  const initials = avatarInitials(name)
  return `<div style="background-color:${color.bg};color:${color.text}" class="w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold flex-shrink-0">${initials}</div>`
}

// Small white avatar for chips in the multiselect preview area (22×22)
export function chipAvatarHtml(name) {
  const initials = avatarInitials(name)
  return `<div class="multiselect__chip-avatar">${initials}</div>`
}
